import robotIcon from "@/assets/Icons/Robot.png";
import workflowIcon from "@/assets/Icons/Workflow.png";
import dashboardIcon from "@/assets/Icons/Dashboard.png";
import { useLanguage } from "@/contexts/LanguageContext";

const About = () => {
  const { t } = useLanguage();
  
  const capabilities = [
    {
      icon: robotIcon,
      title: t.about.capabilities.chatbot.title,
      description: t.about.capabilities.chatbot.description,
    },
    {
      icon: workflowIcon,
      title: t.about.capabilities.automation.title,
      description: t.about.capabilities.automation.description,
    },
    {
      icon: dashboardIcon,
      title: t.about.capabilities.integration.title,
      description: t.about.capabilities.integration.description,
    },
  ];
  return (
    <section className="py-24 md:py-32 bg-background">
      <div className="container px-6 md:px-8">
        {/* Header */}
        <div className="max-w-3xl mx-auto text-center mb-20 animate-fade-in">
          <h2 className="mb-6">
            {t.about.title}
          </h2>
          <p className="text-xl md:text-2xl text-muted-foreground leading-relaxed">
            {t.about.description1}
          </p>
          <p className="text-lg md:text-xl text-muted-foreground mt-4">
            {t.about.description2}
          </p>
        </div>

        {/* Capabilities Grid */}
        <div className="grid md:grid-cols-3 gap-8 md:gap-12 max-w-6xl mx-auto">
          {capabilities.map((capability, index) => (
            <div
              key={index}
              className="text-center group animate-fade-in-up hover-lift p-8 rounded-3xl border border-border bg-gradient-to-b from-card to-accent/30"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <div className="mb-6 flex justify-center">
                  <img 
                    src={capability.icon} 
                    alt={capability.title}
                    className="w-24 h-24 md:w-24 md:h-24 object-contain"
                  />
              </div>
              <h3 className="mb-4 text-xl md:text-2xl">
                {capability.title}
              </h3>
              <p className="text-muted-foreground leading-relaxed">
                {capability.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default About;
